module.exports = "/_next/static/images/nu-971e5c2fb4acc3245687b3b775ec3e0d.svg";